/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDimensionPreview = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M9 2h-.414l-.293.293-6 6A1 1 0 0 0 2 9v12a1 1 0 0 0 1 1h8v-2H4V10h10v4h2V9.414l4-4V14.5h2V3a1 1 0 0 0-1-1zm5.586 6H5.414l4-4h9.172zM12 11H9v2h2v2h2v-4zm-7 4v4h4v-2H7v-2zm12.5 5.99c-.55 0-2.118-.37-3.3-1.985a6.48 6.48 0 0 1 1.07-1.102c.674-.541 1.437-.903 2.23-.903.67 0 2.307.397 3.336 1.972-.27.386-.651.834-1.113 1.212-.665.544-1.396.867-2.145.81l-.04-.004zm0-5.99c-1.407 0-2.602.636-3.482 1.343a8.253 8.253 0 0 0-1.881 2.148l-.295.504.295.505c1.582 2.709 4.08 3.474 5.323 3.49 1.434.099 2.648-.536 3.53-1.258a8.08 8.08 0 0 0 1.888-2.258l.25-.46-.234-.467C21.48 15.724 18.768 15 17.5 15zm0 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgDimensionPreview as DimensionPreview };
